<template>
  <div id="contact">
    <article class="title py-3 bg-primary text-white">
      <b-container
        fluid
        class="d-flex flex-column flex-md-row align-items-md-center justify-content-between"
      >
        <h1 class="text-21 text-lg-32 pl-md-1 fw-700 lh-170">
          내 주변 마을예술창작소 찾아보기
        </h1>
        <div class="mt-4 mt-md-0 ml-md-auto mr-0 d-flex align-items-center">
          <b-input-group class="bg-white rounded">
            <b-input-group-append>
              <i class="icon icon-search m-2"></i>
            </b-input-group-append>
            <b-form-input
              v-model="query"
              class="border-0 bg-transparent"
              placeholder="이름으로 검색하기"
              @keypress.enter="search"
            />
          </b-input-group>
          <div class="ml-2 mr-0">
            <b-btn variant="white" @click="search">
              <span class="text-primary text-nowrap">검색</span>
            </b-btn>
          </div>
        </div>
      </b-container>
    </article>
    <b-modal
      id="map-info-modal"
      title="mapInfo.name"
      size="lg"
      centered
      hide-footer
    >
      <template v-slot:modal-title>
        <div>
          <h2 class="text-18 text-lg-24">{{ mapInfo.name }}</h2>
        </div>
      </template>

      <b-carousel
        ref="carousel"
        class="carousel position-relative over-flow-hidden"
        :interval="4000"
        background="#EEEEEF"
        indicators
        fade
        v-if="mapInfo.imgs.length > 0"
      >
        <b-carousel-slide
          class="slide overflow-hidden"
          img-blank-color="#EEEEEF"
          v-for="(slide, i) in mapInfo.imgs"
          :key="i"
          :style="`backgroundImage:url(${slide})`"
        >
        </b-carousel-slide>
      </b-carousel>
      <ul class="list-unstyled my-3">
        <li class="my-2" v-if="mapInfo.staff !== undefined">
          {{ mapInfo.staff }}
        </li>
        <li class="my-2" v-if="mapInfo.addr !== undefined">
          {{ mapInfo.addr }}
        </li>
        <li class="my-2" v-if="mapInfo.tel !== undefined">{{ mapInfo.tel }}</li>
        <li class="my-2" v-if="mapInfo.website !== undefined">
          <a :href="mapInfo.website" target="_blnak">
            웹사이트
          </a>
        </li>
      </ul>
      <p class="desc my-4 lh-170" v-html="mapInfo.desc"></p>
    </b-modal>
    <article class="row">
      <section ref="map" id="map" class="col-12">
        <GmapMap
          :center="
            screenSize === 'md'
              ? { lat: 37.5448559, lng: 126.980212 }
              : { lat: 37.512559, lng: 126.980212 }
          "
          :zoom="screenSize === 'md' ? 12 : 11"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false,
          }"
          style="width: 100%; height: 100%"
        >
          <gmap-custom-marker
            :key="index"
            v-for="(marker, index) in maps"
            :marker="{
              lat: Number(marker.position.lat),
              lng: Number(marker.position.lng),
            }"
            @click.native="markerFunc(marker)"
            v-b-modal.map-info-modal
            v-b-tooltip.hover
            :title="marker.name"
            class="rounded-circle"
            :style="{
              backgroundColor: marker.color ? marker.color : '#7a2a90',
            }"
          >
            <i
              class="icon icon-24 icon-map-marker"
              :style="{ marginBottom: '-2px' }"
            ></i>
          </gmap-custom-marker>
        </GmapMap>
      </section>
    </article>
  </div>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
import locations from "./lib/map";

export default {
  metaInfo() {
    return {
      titleTemplate: "마을예술창작소 | " + "마술소 찾기",
    };
  },
  components: {
    GmapCustomMarker: GmapCustomMarker,
  },
  data() {
    return {
      mapInfo: {
        name: undefined,
        staff: undefined,
        addr: undefined,
        tel: undefined,
        website: undefined,
        desc: undefined,
        imgs: [],
      },
      markers: locations,
      allMap: [],
      query: null,
    };
  },
  computed: {
    screenSize() {
      const w = screen.availWidth;
      if (w > 414) return "md";
      else if (w <= 414) return "sm";
      else return "";
    },
    meta() {
      return this.$route.meta;
    },
    maps() {
      if (this.meta.search) {
        const query = `${this.$route.query.q}`,
          result = this.allMap.filter((r) => {
            return r.name.includes(query);
          });
        return result;
      } else return this.allMap;
    },
  },
  methods: {
    markerFunc(marker) {
      this.mapInfo = marker;
    },
    loadAllMap() {
      this.$db
        .collection("allMap")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.allMap = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
    href(e) {
      window.open(e);
    },
    search() {
      this.$router.push({
        name: "ContactSearch",
        query: {
          q: this.query,
        },
      });
    },
  },
  mounted() {
    this.loadAllMap();
  },
};
</script>

<style lang="scss" scoped>
#contact,
#map {
  min-height: 100vh;
}

#map-info-modal {
  z-index: 99999 !important;
}

.icon-map-marker {
  cursor: pointer;
}

.carousel {
  height: 24rem !important;
  visibility: visible !important;
  .slide {
    height: 24rem !important;
    background-repeat: no-repeat;
    background-size: cover !important;
  }
}
@media all and (max-width: 768px) {
  .carousel {
    height: 16rem !important;
    .slide {
      height: 16rem !important;
      background-repeat: no-repeat;
      background-size: cover !important;
    }
  }
}

ol.carousel-indicators {
  li {
    width: 12px !important;
    height: 12px !important;
    border-radius: 50% !important;
    background: #7a2a90 !important;
    opacity: 0.6 !important;
    &.active {
      opacity: 1 !important;
    }
  }
}
</style>
